import { render, staticRenderFns } from "./dataAnalysisLayout.vue?vue&type=template&id=352a327d&scoped=true"
import script from "./dataAnalysisLayout.vue?vue&type=script&lang=js"
export * from "./dataAnalysisLayout.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysisLayout.vue?vue&type=style&index=0&id=352a327d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a327d",
  null
  
)

export default component.exports